import gql from 'graphql-tag';

export const validateCaptcha = (attr = `
  isValid
`) => gql`
  query validateCaptcha($token: String) {
    validateCaptcha(token: $token) {
      ${attr}
    }
  }
`;

export default {};
